// src/utils/teamDefaults.js
// Read/write for the single team-wide defaults doc used by the
// post-acceptance email composer (our title closer + broker admin fee).

import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { firestored } from "../firebase/firebaseConfig";

const DOC_PATH = ["settings", "teamDefaults"];

export const TEAM_DEFAULTS_FALLBACK = {
  titleCompany: "Watermark Title",
  titleCloserName: "Julie Davidson",
  titleCloserEmail: "",
  titleCloserPhone: "",
  brokerAdminFee: 599,
};

export async function loadTeamDefaults() {
  try {
    const ref = doc(firestored, ...DOC_PATH);
    const snap = await getDoc(ref);
    if (!snap.exists()) return { ...TEAM_DEFAULTS_FALLBACK };
    return { ...TEAM_DEFAULTS_FALLBACK, ...snap.data() };
  } catch (err) {
    console.error("loadTeamDefaults failed:", err);
    return { ...TEAM_DEFAULTS_FALLBACK };
  }
}

export async function saveTeamDefaults(values, userId) {
  const ref = doc(firestored, ...DOC_PATH);
  await setDoc(ref, {
    ...values,
    updatedAt: serverTimestamp(),
    updatedBy: userId,
  }, { merge: true });
}
